import React, { useState } from 'react'
import { Button, ButtonGroup } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { useGetBusinessID } from '@marketing-milk/frontend'
import { useScreenSize } from 'hooks/useScreenSize'
import { RecentImportsMenu } from './RecentImportsMenu'

/**
 * Importing is the trained way into builder — ads arrive from an existing
 * account and are reviewed here — so it carries the page's primary weight.
 * Getting back into a recent import is the same errand rather than a separate
 * one, so it hangs off this button instead of sitting apart as its own action.
 */
export const CreativeImportButton = () => {
  const { isMobile } = useScreenSize()
  const history = useHistory()
  const businessID = useGetBusinessID()
  const [recentAnchor, setRecentAnchor] = useState<HTMLElement | null>(null)

  return (
    <>
      <ButtonGroup variant="contained" color="primary">
        <Button
          aria-label="Import ads"
          onClick={() => history.push(`/${businessID}/creatives/import`)}
        >
          {isMobile ? <i className="fad fa-file-import" aria-hidden /> : 'Import ads'}
        </Button>
        <Button
          aria-label="Recent imports"
          aria-haspopup="menu"
          sx={{ px: 1, minWidth: 0 }}
          onClick={event => setRecentAnchor(event.currentTarget)}
        >
          <i className="fa fa-chevron-down text-xs" aria-hidden />
        </Button>
      </ButtonGroup>
      <RecentImportsMenu anchorEl={recentAnchor} onClose={() => setRecentAnchor(null)} />
    </>
  )
}
